const addressTypes = {
	all: "all",
	saved: "saved",
	pitstop: "pitstop",
}

export default addressTypes
